'use strict';

/* global angular _ */
angular.module('atex.aceui.service').factory('StructureService',
  ['$q', '$rootScope', 'AuthenticationService', 'ApplicationConfigurationService',

    function ($q, $rootScope, AuthenticationService, ApplicationConfigurationService) {
      var serviceHandler = undefined;

      var handler = function () {
        if (serviceHandler !== undefined) {
          return $q.when(serviceHandler);
        }

        return ApplicationConfigurationService.getServiceConfigurationFor('StructureService').then(function (configuration) {
          var serviceUrl = atex.aceui.ServiceUtils.calculateServiceUrl(configuration, 'structure');

          var serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope), cacheBusting: atex.aceui.BrowserUtils.isSafariBrowser() };
          serviceHandler = atex.aceui.service.StructureService(serviceUrl, serviceSettings);

          return serviceHandler;
        });
      };

      return {
        /**
         * Get the content structure where the content with "alias" is the root.
         * @param {Object} transferInfo
         * @param {string} transferInfo.alias Alias of the content that is the root of the structure
         * @returns {Promise} Resolved with the content structure
         */
        getContentStructure: function (transferInfo) {
          return AuthenticationService.callWithAuthentication(function (currentUser) {
            return handler().then(function (serviceHandler) {
              return serviceHandler.getContentStructure(_.extend(transferInfo, { token: currentUser.token }));
            });
          });
        }
      };
    }
  ]);
